import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};


@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private baseUrl = 'https://api.decentralrealty.io/static/';

  constructor(private http: HttpClient) { }

  async fetchData(token: string) {
    const url = `${this.baseUrl}acc_bal_${token}.json`;
    return firstValueFrom(this.http.get(url, httpOptions))
      .then((data) => {
        //console.log(`Result: ` + data);
        return data;
      })

  }
  

}
